import { FORM_INDEX as o } from "./index359.mjs";
function s(f, r) {
  return r ? typeof r == "boolean" ? r : Array.isArray(r) ? r.includes(f.replace(/[.][0-9]/g, `.${o}`)) : !1 : !1;
}
export {
  s as shouldValidateOnChange
};
